import _Symbol from "@babel/runtime-corejs3/core-js/symbol";
import _Number$isInteger from "@babel/runtime-corejs3/core-js/number/is-integer";
import React from "react";
const $min = _Symbol('min');
const $max = _Symbol('max');
export class InclusiveRange {
  constructor(min, max) {
    if (typeof min !== 'number' || typeof max !== 'number') {
      throw TypeError('Expected min and max to be numbers');
    }
    if (min > max) {
      throw TypeError('Expected min to be less than or equal to max');
    }
    if (!_Number$isInteger(min) || !_Number$isInteger(max)) {
      throw TypeError('Expected min and max to be integers');
    }
    this[$min] = min;
    this[$max] = max;
  }
  get min() {
    return this[$min];
  }
  get max() {
    return this[$max];
  }
  map(mapper) {
    return new this.constructor(mapper(this[$min]), mapper(this[$max]));
  }
  includes(number) {
    return number >= this.min && number <= this.max;
  }
  get length() {
    return Math.max(this.max - this.min + 1, 0);
  }
  restrict(number) {
    return Math.min(this.max, Math.max(this.min, number));
  }
}
export class ExclusiveRange extends InclusiveRange {
  get min() {
    return this[$min] + 1;
  }
  get max() {
    return this[$max] - 1;
  }
}
export const useInclusiveRange = (min, max) => React.useMemo(() => new InclusiveRange(min, max), [min, max]);